
import Input from "../Input";
import Output from "../Output";
import switchImage from "../../assets/switch.png";


import albanian from "../../assets/alban.png"

import { Helmet } from 'react-helmet-async';


function AlbanMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Albán magyar fordító</title>
                <meta name='description' content='Albán-magyar fordítónk szavak, kifejezések, és hoszzú szövegek fordítására egyaránt alkalmas.' />
                <meta title="Albán-magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/alban-magyar-fordito" />
            </Helmet>
            <h1>Albán magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage} alt="nyelvcsere"></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>Az albán nyelvről</h2>
                    <img src={albanian} alt="Albán zászló"></img>

                </div>



                <p>Az albán nyelv hosszú múltra tekint vissza, gyökerei az ősi illyr nyelvre vezethetők vissza, amely egy kihalt indoeurópai nyelv, amelyet a Balkánon beszéltek. Történelme során az albán nyelvre különböző nyelvek gyakoroltak hatást, többek között a latin, a görög, a szláv, a török és az olasz. Sikerült azonban megőriznie egyedi identitását, és az illír ág kevés fennmaradt nyelvének egyike maradt.</p>

                <p>Az albán nyelv nyelvtani és hangtani sajátosságairól ismert. Két fő nyelvjárásra oszlik: Gheg és Tosk. A gheget Észak-Albániában, Koszovóban és Montenegró egyes részein beszélik, míg a toszkot Dél-Albániában és Görögországban. Ezek a nyelvjárások kiejtésben, szókincsben és bizonyos nyelvtani vonatkozásokban különböznek egymástól.</p>


                <p>Az albán nyelv egyik jellegzetessége a nyelvtani nemek rendszere. Sok indoeurópai nyelvvel ellentétben, amelyekben a hím és nőneműek vannak, az albánban háromféle nem létezik: hímnemű, nőnemű és nemtelen. Ez a jellegzetesség más balkáni nyelvekben is megtalálható, ami közös nyelvi örökségre utal.</p>

                <p>Az albán nyelvben a főnevek deklinációs rendszere összetett, többféle esetet tartalmaz: nominativus, akkuzatív, genitivus, dativus, ablativus és vokativus. Az albán igealakokat az idő, a mód, az aspektus és a hang alapján konjugálják. A nyelv szókincse is gazdag, és különböző nyelvekből származó kölcsönszavakat tartalmaz.</p>

                <p>Az írást illetően az albán nyelv a latin ábécé módosított változatát használja, amely 36 betűből áll. A nyelv ortográfiája a történelem során reformokon ment keresztül, a legjelentősebb változásokra a 20. században került sor az írásrendszer egységesítése érdekében.</p>

                <p>Viszonylag kis számú beszélője ellenére az albán nyelv jelentős szerepet játszott az irodalomban, a költészetben és a kulturális kifejezésben. Olyan kiemelkedő albán írók és költők, mint Ismail Kadare és Naim Frashëri, hozzájárultak az ország irodalmi örökségéhez. Emellett az albán nyelvet számos területen használták, többek között az oktatásban, a médiában és a közigazgatásban.</p>

                <p>Az utóbbi években erőfeszítések történtek az albán nyelv népszerűsítésére és kulturális örökségének megőrzésére. Albánia és Koszovó nyelvpolitikái hangsúlyozták az albán nyelv fontosságát az oktatásban és a hivatalos intézményekben, biztosítva annak folyamatos életképességét és fejlődését.</p>

                <p>Összességében az albán nyelv az indoeurópai nyelvcsalád lenyűgöző része, saját egyedi jellegzetességeivel és kulturális jelentőségével. Gazdag történelme és sajátos vonásai miatt a nyelvészek és a balkáni nyelvek iránt érdeklődők érdeklődésének tárgya.</p>

                <h2>Albán magyar különbségek</h2>

                <ul>
                    <li><b>Nyelvcsalád</b>: Az albán az indoeurópai nyelvcsaládba tartozik, különösen az albán nyelvcsaládnak nevezett ágba. A magyar viszont nem indoeurópai nyelv, hanem az uráli nyelvcsaládba tartozik.</li>

                    <li><b>Szókincs</b>: Az albán nyelv szókincse elsősorban az indoeurópai nyelvcsaládból származik, jelentős latin, görög és török hatásokkal. A magyar nyelv ezzel szemben finnugor szókincsű, ami megkülönbözteti az indoeurópai nyelvektől.</li>


                    <li><b>Nyelvtan</b>: Az albán nyelvtan a magyarhoz képest összetettebb nyelvtannal rendelkezik. Ez egy flektált nyelv, ami azt jelenti, hogy a szavak végződését megváltoztatják, hogy jelezzék a nyelvtani funkciókat, mint például az esetet, a számot és a nemet. A magyar, mint már említettük, szintén flektált nyelv, de agglutinációt követ, ahol az utótagok a nyelvtani információk kifejezésére a szótövekhez kapcsolódnak.</li>

                    <li><b>Szórend</b>: Az albán jellemzően alany-ige-tárgy (SVO) szórendet követ, hasonlóan az angolhoz. Gazdag esetrendje miatt azonban nagyobb rugalmasságot tesz lehetővé. A magyar általában alany-tárgy-ige (SOV) szórendet követ, bár agglutináló jellege miatt némi rugalmasságot is megenged.</li>



                    <li><b>Kiejtés</b>: Az albán nyelv fonetikai rendszerrel rendelkezik, amelyben minden betű egy adott hangnak felel meg. Egyszerű kiejtése van, korlátozott variációval. A magyar nyelv hasonlóan egységes kiejtési szabályokkal rendelkező fonetikai rendszerrel rendelkezik, így az angolhoz képest viszonylag könnyebben kiejthető.</li>

                    <li><b>Rokonai</b>: Az albán és a magyar különböző nyelvcsaládokból származik, így nagyon kevés rokon értelmű vagy közös etimológiájú szóval rendelkeznek. Ezért a szókincs elsajátítása bármelyik nyelven kihívást jelenthet a másik nyelv beszélői számára.</li>

                    <li><b>Befolyás</b>: A földrajzi közelségük miatt az albán és a magyar nyelv között történelmi hatások voltak, különösen a kölcsönszavak tekintetében. Ezek a hatások azonban viszonylag korlátozottak az albán és más szomszédos indoeurópai nyelvek közötti kiterjedt kölcsönhatásokhoz képest.</li>
                </ul>
                <p>Ezek a legfontosabb különbségek az albán és a magyar között. Annak ellenére, hogy a flektálás és a szórend tekintetében van néhány hasonlóság, ezek különböző nyelvek, különböző nyelvcsaládokkal, szókészlettel és nyelvtani szerkezetekkel.</p>



            </section>
        </>

    )
}

export default AlbanMagyar;